import React, {createContext, useContext, useState, ReactNode, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {getUsers} from '../../_common/components/Users/actions/UsersActions';
import {Option} from "../../_common/types";

interface RootState {
  usersReducer: { users: Option<number>[] }
}

type PageContextType = {
  priceQuoteID: number;
  showLinkModal: boolean;
  setShowLinkModal: React.Dispatch<React.SetStateAction<boolean>>;
  users: Option<number>[];
  isTab1Valid: boolean;
  setIsTab1Valid: React.Dispatch<React.SetStateAction<boolean>>;
  isTab2Valid: boolean;
  setIsTab2Valid: React.Dispatch<React.SetStateAction<boolean>>;
  isTab3Valid: boolean;
  setIsTab3Valid: React.Dispatch<React.SetStateAction<boolean>>;
};

const PageContext = createContext<PageContextType | undefined>(undefined);

export function usePageContext(): PageContextType {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext must be used within PageProvider');
  }
  return context;
}

type PageProviderProps = {
  children: ReactNode;
};

export function PageProvider({ children }: PageProviderProps) {
  const dispatch = useDispatch();
  const [showLinkModal, setShowLinkModal] = useState<boolean>(false);
  const [isTab1Valid, setIsTab1Valid] = useState<boolean>(true);
  const [isTab2Valid, setIsTab2Valid] = useState<boolean>(true);
  const [isTab3Valid, setIsTab3Valid] = useState<boolean>(true);

  const location = useLocation();
  const pathName = location.pathname;

  const priceQuoteID = parseInt(pathName.replace('/price-quote-details/', ''), 10) || 0;

  useEffect(() => {
    dispatch(getUsers());
  }, [])

  const {users} = useSelector(
    (state: RootState) => ({
      users: state.usersReducer.users,
    }),
    shallowEqual
  );

  const value: PageContextType = {
    priceQuoteID,
    showLinkModal,
    setShowLinkModal,
    users: users || [],
    isTab1Valid,
    setIsTab1Valid,
    isTab2Valid,
    setIsTab2Valid,
    isTab3Valid,
    setIsTab3Valid
  };

  return (
    <PageContext.Provider value={value}>
      {children}
    </PageContext.Provider>
  );
}